export default {
	methods: {
		/**
		 * Return color depending on the score
		 * @param {number} score - Score of the metric
		 * @return {string} Returns the color as string
		 */
		getColorForScore: score => {
			let color = "";
			if(score >= 0.9) {
				color = "#20E647";
			}
			if(score <= 0.49) {
				color = "#ff4e42";
			}
			if(score >= 0.5 && score <= 0.89) {
				color = "#ffa400";
			}
			if(score == null) {
				color = "#bdbdbd";
			}
			return color;
		},

		/**
		 * Return theme color depending on the score
		 * @param {number} score - Score of the metric
		 * @return {string} Returns the color as string
		 */
		getThemeColorForScore: score => {
			let color = "";
			if(score >= 0.9) {
				color = "success";
			}
			if(score <= 0.49) {
				color = "danger";
			}
			if(score >= 0.5 && score <= 0.89) {
				color = "warning";
			}
			return color;
		},

		/**
		 * Return icon depending on the score
		 * @param {number} score - Score of the metric
		 * @return {string} Returns the color as string
		 */
		getIconForScore: score => {
			let color = "";
			if(score >= 0.9) {
				color = "CheckCircleIcon";
			}
			if(score <= 0.49) {
				color = "AlertCircleIcon";
			}
			if(score >= 0.5 && score <= 0.89) {
				color = "MinusCircleIcon";
			}
			return color;
		}
	}
};
